import { message } from 'antd';
import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWith409 from './baseQueryWith409';
import qs from 'qs';
import fetch from 'auth/FetchInterceptor';

// direct fetch without RTK Query
export const getTrabajosEJ = query =>
	fetch.get(
		`/trabajos-ej${
			query
				? `?${qs.stringify(
						{ ...query, publicationState: 'live' },
						{
							encodeValuesOnly: true,
						}
				  )}`
				: ''
		}`
	);
export const getTrabajoEJ = ({ id, query }) =>
	fetch.get(
		`/trabajos-ej/${id}${
			query
				? `?${qs.stringify(
						{ ...query, publicationState: 'live' },
						{
							encodeValuesOnly: true,
						}
				  )}`
				: ''
		}`
	);
export const addTrabajoEJ = data => fetch.post('/trabajos-ej', data);
export const updateTrabajoEJ = ({ id, ...data }) =>
	fetch.put(`/trabajos-ej/${id}`, data);
export const deleteTrabajoEJ = id => fetch.delete(`/trabajos-ej/${id}`);

// RTK Query
export const trabajosEjApi = createApi({
	reducerPath: 'trabajosEjApi',
	baseQuery: baseQueryWith409,

	// default configuration
	refetchOnReconnect: true,
	refetchOnMountOrArgChange: true,
	refetchOnFocus: true,

	//endpoints
	endpoints: build => ({
		getTrabajosEj: build.query({
			query: query => {
				return {
					url: `/trabajos-ej${
						query
							? `?${qs.stringify(
									{ ...query, publicationState: 'live' },
									{
										encodeValuesOnly: true,
									}
							  )}`
							: ''
					}`,
					method: 'GET',
				};
			},
			transformResponse: response => response.data,
			providesTags: result =>
				// is result available?
				result
					? // successful query
					  [
							...result.map(({ id }) => ({ type: 'TrabajosEj', id })),
							{ type: 'TrabajosEj', id: 'LIST' },
					  ]
					: // an error occurred, but we still want to refetch this query when `{ type: 'Posts', id: 'LIST' }` is invalidated
					  [{ type: 'TrabajosEj', id: 'LIST' }],
		}),
		getTrabajoEj: build.query({
			query: ({ id, query }) => {
				return {
					url: `/trabajos-ej/${id}${
						query
							? `?${qs.stringify(
									{ ...query, publicationState: 'live' },
									{
										encodeValuesOnly: true,
									}
							  )}`
							: ''
					}`,
					method: 'GET',
				};
			},
			transformResponse: response => response.data,
			providesTags: (result, error, id) => [{ type: 'TrabajosEj', id }],
		}),
		addTrabajoEj: build.mutation({
			query: data => {
				const user = JSON.parse(localStorage.getItem('me'));
				return {
					url: `/trabajos-ej`,
					method: 'POST',
					body: JSON.stringify({
						data: {
							...data,
							created_by_user: user.id,
						},
					}),
				};
			},
			onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
				// try catch with antd message when fulfilled and rejected
				try {
					await queryFulfilled;
					message.success(
						'Trabajo Estudio Jurídico agregado exitosamente'
					);
				} catch (error) {
					message.error('Error al agregar trabajo estudio jurídico');
					if (error.error.data?.error) {
						message.error(error.error.data?.error.message);
					}
				}
			},
			invalidatesTags: [{ type: 'TrabajosEj', id: 'LIST' }],
		}),
		updateTrabajoEj: build.mutation({
			query: ({ id, ...data }) => {
				const user = JSON.parse(localStorage.getItem('me'));
				return {
					url: `/trabajos-ej/${id}`,
					method: 'PUT',
					body: JSON.stringify({
						data: {
							...data,
							updated_by_user: user.id,
						},
					}),
				};
			},
			onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
				// try catch with antd message when fulfilled and rejected
				try {
					await queryFulfilled;
					message.success(
						'Trabajo Estudio Jurídico actualizado exitosamente'
					);
				} catch (error) {
					message.error('Error al actualizar trabajo estudio jurídico');
					if (error.error.data?.error) {
						message.error(error.error.data?.error.message);
					}
				}
			},
			invalidatesTags: (result, error, { id }) => [
				{ type: 'TrabajosEj', id },
			],
		}),
		deleteTrabajoEj: build.mutation({
			query: id => {
				const user = JSON.parse(localStorage.getItem('me'));
				return {
					url: `/trabajos-ej/${id}`,
					method: 'PUT',
					body: JSON.stringify({
						data: {
							publishedAt: null,
							updated_by_user: user.id,
						},
					}),
				};
			},
			onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
				// try catch with antd message when fulfilled and rejected
				try {
					await queryFulfilled;
					message.success(
						'Trabajo Estudio Jurídico eliminado exitosamente'
					);
				} catch (error) {
					message.error('Error al eliminar trabajo estudio jurídico');
					if (error.error.data?.error) {
						message.error(error.error.data?.error.message);
					}
				}
			},
			invalidatesTags: (result, error, id) => [{ type: 'TrabajosEj', id }],
		}),
	}),
});

export const {
	useGetTrabajosEjQuery,
	useGetTrabajoEjQuery,
	useAddTrabajoEjMutation,
	useUpdateTrabajoEjMutation,
	useDeleteTrabajoEjMutation,
} = trabajosEjApi;
